import React, { useState, useCallback } from 'react';
import { Row, Col, Button } from 'react-bootstrap5';

import PermissionsGate from 'components/Users/PermissionsGate';
import Templates from 'components/Managers/Programs/Views/List/Templates';
import ModalCreateMethod from './ModalCreateMethod';

export default function Index() {
  const [showCreateMethodModal, setShowCreateMethodModal] = useState(false);

  const closeChooseCreateMethod = useCallback(() => {
    setShowCreateMethodModal(false);
  }, []);

  return (
    <div className="content">
      <section>
        <Row className="mb-3">
          <Col>
            <h1>Programs</h1>
          </Col>

          <PermissionsGate scopes={{ 'Create Programs': ['edit'] }}>
            <Col xs="auto">
              <Button
                onClick={() => setShowCreateMethodModal(true)}
              >
                Build New Program
              </Button>
            </Col>
          </PermissionsGate>
        </Row>

        <p>
          Manage your programs and assign your members.
        </p>
      </section>

      <Templates mainAction="edit" />

      <ModalCreateMethod show={showCreateMethodModal} onClose={closeChooseCreateMethod} />
    </div>
  );
}
